import classNames from "classnames";
import {
  ChangeEvent,
  FC,
  useContext,
  useEffect,
  useRef,
  useState
} from "react";
import { CircleStencil, Cropper, CropperRef } from "react-advanced-cropper";
import "react-advanced-cropper/dist/style.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "../../common/axios";
import Button from "../../components/bootstrap/Button";
import Collapse from "../../components/bootstrap/Collapse";
import {
  DropdownItem,
  DropdownMenu
} from "../../components/bootstrap/Dropdown";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader
} from "../../components/bootstrap/Modal";
import Icon from "../../components/icon/Icon";
import AuthContext, { IAuthContextProps } from "../../contexts/authContext";
import useDarkMode from "../../hooks/useDarkMode";
import useNavigationItemHandle from "../../hooks/useNavigationItemHandle";
import { demoPagesMenu } from "../../menu";
import { NavigationLine } from "../Navigation/Navigation";

const User = () => {
  //const { userData, setUser } = useContext(AuthContext);
  // const [userData, setUserData] = useState({
  //   fullName: "",
  //   username: "",
  //   agency: { agency_name: null },
  //   avatar: UserImage4,
  // });

  const navigate = useNavigate();
  const handleItem = useNavigationItemHandle();
  const { darkModeStatus, setDarkModeStatus } = useDarkMode();
  const { userData } = useContext<IAuthContextProps>(AuthContext);

  const [collapseStatus, setCollapseStatus] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);

  const { t } = useTranslation(["translation", "menu"]);

  // console.log(userData);
  const onLogout = async () => {
    await axios.get("/logout").then((res) => {});
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    localStorage.removeItem("facit_authUsername");
    navigate(`../${demoPagesMenu.login.path}`);
  };
  return (
    <>
      <div
        className={classNames("user", { open: collapseStatus })}
        role="presentation"
        onClick={() => setCollapseStatus(!collapseStatus)}
      >
        <div className="user-avatar">
          <img src={userData?.avatar} alt="Avatar" width={128} height={128} />
        </div>
        <div className="user-info">
          <div className="user-name d-flex align-items-center">
            {`${userData.full_name}`}
            <Icon icon="Verified" className="ms-1" color="info" />
          </div>
          <div className="user-sub-title">{userData.agency_name}</div>
        </div>
      </div>
      <DropdownMenu>
        <DropdownItem>
          <Button icon="AccountBox" onClick={() => navigate("profile")}>
            Profile
          </Button>
        </DropdownItem>
        <DropdownItem>
          <Button
            icon={darkModeStatus ? "DarkMode" : "LightMode"}
            onClick={() => setDarkModeStatus(!darkModeStatus)}
            aria-label="Toggle fullscreen"
          >
            {darkModeStatus ? "Dark Mode" : "Light Mode"}
          </Button>
        </DropdownItem>
      </DropdownMenu>

      <Collapse isOpen={collapseStatus} className="user-menu">
        <nav aria-label="aside-bottom-user-menu">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => navigate("profile")}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="AccountBox" className="navigation-icon" />
                  <span className="navigation-text">
                    {/* {t('menu:Profile') as ReactNode} */}
                    Thông tin người dùng
                  </span>
                </span>
              </span>
            </div>
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => setShow(true)}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="CameraAlt" className="navigation-icon" />
                  <span className="navigation-text">
                    {/* {t('menu:Profile') as ReactNode} */}
                    Cập nhật ảnh đại diện
                  </span>
                </span>
              </span>
            </div>
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => navigate("forgot-password")}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="Lock" className="navigation-icon" />
                  <span className="navigation-text">Đổi mật khẩu</span>
                </span>
              </span>
            </div>
          </div>
        </nav>
        <NavigationLine />
        <nav aria-label="aside-bottom-user-menu-2">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={onLogout}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="Logout" className="navigation-icon" />
                  <span className="navigation-text">
                    {/* {t('menu:Logout') as ReactNode} */}
                    Đăng xuất
                  </span>
                </span>
              </span>
            </div>
          </div>
        </nav>
        <ModalAvatar setIsOpen={setShow} isOpen={show} />
      </Collapse>
    </>
  );
};

export default User;

const ModalAvatar: FC<{ isOpen: boolean; setIsOpen: any }> = ({
  isOpen,
  setIsOpen,
}) => {
  const img = useRef<HTMLInputElement | null>(null);
  const imageNewCrop = useRef<CropperRef>(null);
  const [imgeNew, setImageNew] = useState<string>("");
  const [imageOld, setImageOld] = useState<string>("");
  const [isMess, setIsMess] = useState<boolean>(false);
  const { userData, setUserData } = useContext<IAuthContextProps>(AuthContext);

  const readUploadFile = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (e: any) => {
        setImageNew(e.target.result);
      };
    }
    e.target.value = "";
  };

  const onCrop = () => {
    if (imageNewCrop.current) {
      axios
        .post("/updateUserInfo", {
          avatar: imageNewCrop.current.getCanvas()?.toDataURL(),
        })
        .then((res) => {
          setImageOld(imageNewCrop.current?.getCanvas()?.toDataURL() || "");
          setImageNew("");

          setUserData({
            ...userData,
            avatar: imageNewCrop.current?.getCanvas()?.toDataURL(),
          });
          setIsMess(true);
        })
        .catch((err) => console.log(""));
    }
  };
  useEffect(() => {
    setImageOld(userData.avatar || "");
  }, [userData]);

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <ModalHeader
        setIsOpen={(open) => {
          setIsOpen(open);
          setIsMess(false)
        }} // Example: setState
        children={undefined}
      />
      <ModalBody style={{ display: "flex", flexDirection: "column" }}>
        <p
          style={{
            fontWeight: 500,
            fontSize: 30,
            color: "#000000",
            textAlign: "center",
          }}
        >
          Cập nhật ảnh đại diện
        </p>
        {!imgeNew ? (
          <>
            <div
              className="rounded-circle border mx-auto my-4"
              style={{ width: 300, height: 300, overflow: "hidden" }}
            >
              <img src={imageOld} alt="avatar" width={"100%"} height={"100%"} />
            </div>
            {isMess && (
              <p
                style={{
                  fontWeight: 500,
                  fontSize: 16,
                  color: "#384DC0",
                  textAlign: "center",
                }}
              >
                Cập nhập ảnh đại diện THÀNH CÔNG
              </p>
            )}
            <ModalFooter>
              <div className="d-flex w-100 justify-content-evenly">
                <input
                  type="file"
                  ref={img}
                  className="d-none"
                  onChange={readUploadFile}
                  accept="image/*"
                />
                <Button
                  color="primary"
                  className="px-5"
                  isOutline
                  onClick={() => {
                    img.current?.click();
                  }}
                >
                  Thay đổi
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    setIsOpen(false)
                    setIsMess(false)
                  }}
                  className="px-5"
                >
                  Đóng
                </Button>
              </div>
            </ModalFooter>
          </>
        ) : (
          <>
            <div style={{ maxHeight: 500 }}></div>
            <Cropper
              style={{ height: 400, width: "100%" }}
              src={imgeNew}
              className={"cropper"}
              ref={imageNewCrop}
              stencilComponent={CircleStencil}
            />
            <p style={{ fontSize: 16, textAlign: "center", marginTop: 16 }}>
              Di chuyển khung tròn để đặt lại vị trí
            </p>
            <ModalFooter>
              <div className="d-flex w-100 justify-content-evenly">
                <input
                  type="file"
                  ref={img}
                  className="d-none"
                  onChange={readUploadFile}
                  accept="image/*"
                />

                <Button
                  color="primary"
                  onClick={() => setImageNew("")}
                  className="px-5"
                >
                  Hủy
                </Button>
                <Button
                  color="primary"
                  className="px-5"
                  isOutline
                  onClick={() => onCrop()}
                >
                  Cập nhật
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};
